import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { InfoDialogComponent } from '../../dialogs/info-dialog/info-dialog.component';
import { AlteracaoSenhaDTO } from '../../dtos/alteracao-senha-dto';
import { AuthenticationService } from '../../login/authentication/authentication.service';
import { UsuarioService } from '../../usuario/usuario.service';
import { passwordMatchValidator } from '../../validators/password.validator';

@Component({
  selector: 'app-redefinir-senha',
  templateUrl: './redefinir-senha.component.html',
  styleUrls: ['./redefinir-senha.component.css']
})
export class RedefinirSenhaComponent implements OnInit {

  formularioRedefinicaoSenha: FormGroup;

  constructor(private usuarioService: UsuarioService,
    private formBuilder: FormBuilder,
    private authenticationService: AuthenticationService,
    private dialog: MatDialog) {

    this.formularioRedefinicaoSenha = this.formBuilder.group({
      senhaAtual: ['', [Validators.required]],
      novaSenha: ['', [Validators.required, Validators.minLength(6)]],
      confirmarNovaSenha: ['', [Validators.required, Validators.minLength(6)]]
    }, { validator: passwordMatchValidator }
    );
  }

  ngOnInit() {

    this.configurarForm();

  }

  save() {

    const alteracaoSenhaDTO: AlteracaoSenhaDTO = this.formularioRedefinicaoSenha.value;

    this.usuarioService
      .alterarSenhaDoUsuario(alteracaoSenhaDTO).subscribe(data => {
        // console.log(data)

        const dialogRef = this.dialog.open(InfoDialogComponent, {
          data: {
            title: 'Info',
            message: 'Senha alterada com sucesso. Favor logar novamente!'
          }
        });

        dialogRef.afterClosed().subscribe(result => {
          this.sair();
        });

      }, error => {
        console.log(error);
      });
  }

  onSubmit() {
    this.save();
  }

  sair(): void {
    this.authenticationService.logout();
  }

  configurarForm(): void {

    this.formularioRedefinicaoSenha.setValue({
      senhaAtual: '',
      novaSenha: '',
      confirmarNovaSenha: ''
    });
  }

  get novaSenha() {
    return this.formularioRedefinicaoSenha.get('novaSenha');
  }

  get confirmarNovaSenha() {
    return this.formularioRedefinicaoSenha.get('confirmarNovaSenha');
  }

  onPasswordInput() {
    if (this.formularioRedefinicaoSenha.hasError('passwordMismatch'))
      this.confirmarNovaSenha?.setErrors([{ 'passwordMismatch': true }]);
    else
      this.confirmarNovaSenha?.setErrors(null);
  }
}
